import React from 'react';
import { Row, Col } from 'barnyard/layouts';
import { Image } from 'barnyard/components';
import { static_url } from '~/app/common/globals';

const classNamePrefix = 'Accounts--header';

const HeaderDesktop = () => (
  <Row align='middle' justify='center' className={classNamePrefix}>
    <Col span={0}>
      <Image
        onClick={() => window.location = '/'}
        className={`${classNamePrefix}__img`}
        src={`${static_url}img/logos/vetcove/logo_200x41.png`}
      />
    </Col>
  </Row>
);

export default HeaderDesktop;
